<template>
  <input
    type="hidden"
    v-bind="Object.assign({}, attributes, $attrs)"
    v-on="Object.assign({}, listeners, $listeners, { input: updateValue })"
    :value="value"
    class="form__input"
  />
</template>

<script>
import BaseInput from '../BaseInput'
export default {
  name: 'CycleHiddenInput',
  extends: BaseInput,
  methods: {
    updateValue(event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>
